<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px;border-radius: 10px;">

      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter the ATC Class or Brand Name</p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
            <i class="fa fa-search icon" style="margin-right: 10px;"></i>
            <input class="w-75" placeholder="Enter the ATC Class or Brand Name" [(ngModel)]="searchValue"
              (keydown.enter)="searchMolecule()" autofocus>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
          </div>

        </div>

      </div>
    </div>
    <table class="table table-striped table-bordered text-center">
      <thead>
        <tr>
          <th scope="col" style="font-weight: bold">ATC Class</th>
          <th scope="col" style="font-weight: bold">ATC SubClass</th>
          <th scope="col" style="font-weight: bold">Approval Year</th>
          <th scope="col" style="font-weight: bold">Innovator</th>
          <th scope="col" style="font-weight: bold">Generic name</th>
          <th scope="col" style="font-weight: bold">Brand Name</th>
          <th scope="col" style="font-weight: bold"> RoA</th>
          <th scope="col" style="font-weight: bold">Dosage form</th>
          <th scope="col" style="font-weight: bold">Strength</th>
          <th scope="col" style="font-weight: bold">Pack Size</th>
          <th scope="col" style="font-weight: bold">Pack price</th>
          <th scope="col" style="font-weight: bold">Per unt price</th>
          <th scope="col" style="font-weight: bold">calculation button</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let company of allMoleculeData ; let first = first; index as i">
          <tr>
            <td *ngIf="first" [attr.rowspan]="allMoleculeData.length">
              {{ searchValue }}
            </td>
            <td>
              {{ company['ATC SubClass'] || '-' }}
            </td>
            <td>
              {{ company['Approval Year'] || '-'}}
            </td>
            <td>
              {{ company['Innovator'] || '-'}}
            </td>
            <td>
              {{ company['Generic name'] || '-'}}
            </td>
            <td>
              {{ company['Brand name'] || '-'}}
            </td>
            <td>
              {{ company['Route of Administration'] || '-'}}
            </td>
            <td>
              {{ company['Dosage form'] || '-'}}
            </td>
            <td>
          <tr *ngFor="let data of company.Strengths">
            <td>{{data.Strength || '-'}}</td>
          </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Pack Size'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Pack price'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Per unt price'] || 0}}</td>
            </tr>
          </td>
          <td *ngFor="let data of company.Strengths; index as j">
            <button *ngIf="company.calcBtn == true"
              (click)="calculateMolecule(i, j, searchValue, company['NDA number'], data.Strength,company['Generic name'])">Calculate</button>

            <button *ngIf="company.saveBtn == true"
              (click)="saveMolecule(data['Per unt price'], data.Strength, company['NDA number'])">Save</button>
            <ng-template #view>
              -
            </ng-template>
          </td>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>